var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-badge"},[_c('span',{staticClass:"dot text-center pl-1"},[_c('i',{staticClass:"orange-icon",class:_vm.i})]),_c('span',{staticClass:"tag-badge-title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }